import React from 'react';
import PropTypes from 'prop-types';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';
import { FooterDisclosureWrapper } from '@paypalcorp/pp-com-components-pds60/components/FooterDisclosureWrapper';

export function QuantumLeapFooter({
  belowFooter, footerTheme, skipFooter, isPayPalAppWebview,
}) {
  const hasBelowFooter = Array.isArray(belowFooter)
    ? belowFooter.length > 0
    : Boolean(belowFooter);

  // SDK omits the footer fragment (and its disclosure markers) when hidden or in a webview.
  const footerNavHidden = skipFooter || isPayPalAppWebview;

  if (footerNavHidden) {
    if (!hasBelowFooter) {
      return null;
    }
    return (
      <div className="document-footer">
        {/* Mirrors the SDK's footer wrapper for disclosure styling. */}
        <div id="globalnav-footer-wrapper">
          <FooterDisclosureWrapper theme={footerTheme}>
            <div className="grid" style={{ paddingTop: "4vw" }}>
              {belowFooter}
            </div>
          </FooterDisclosureWrapper>
        </div>
      </div>
    );
  }

  return (
    <div className="document-footer">
      <NavFragment type="footer">
        {hasBelowFooter
          ? (
            <NavFragment.After>
              <FooterDisclosureWrapper theme={footerTheme}>
                {/* Fragment needed since belowFooter can be `[<Suspense />]`. */}
                {/* eslint-disable-next-line react/jsx-no-useless-fragment */ }
                <>
                  {belowFooter}
                </>
              </FooterDisclosureWrapper>
            </NavFragment.After>
          ) : null}
      </NavFragment>
    </div>
  );
}

QuantumLeapFooter.propTypes = {
  belowFooter: PropTypes.node,
  footerTheme: PropTypes.string,
  skipFooter: PropTypes.bool,
  isPayPalAppWebview: PropTypes.bool,
};

QuantumLeapFooter.defaultProps = {
  belowFooter: null,
  footerTheme: "primary",
  skipFooter: false,
  isPayPalAppWebview: false,
};
